import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TrackableList, TrackableObjectType } from 'types/trackables';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';
import { TagParams } from 'tags/types/tagged';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

export type UseTrackableListsParams = TagParams & {
  trackable_list_ids?: string[];
  trackable_list_names?: string[];
  object_types?: TrackableObjectType[];
};

type UseTrackableListsOptions = UseQueryOptions<OffsetPaginated<TrackableList>, APIError> & {
  params?: UseTrackableListsParams & OffsetPaginationParams;
};

export function useTrackableLists({
  queryKey = ['trackable-lists'],
  params,
  ...options
}: UseTrackableListsOptions = {}) {
  const { applicationID, client } = useAPI();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      const { data } = await client.get(`/apps/${applicationID}/trackables`, {
        params: queryParams,
      });
      return data;
    },
    options
  );
}